import { CustomDataSearchFieldModel } from '../../custom-data/_index';

export interface ExportTemplateConfigurationModel {
  requiredFields?: string[];
  includedExportTemplates?: IncludedExportTemplateModel[];
  multipleSupport?: TemplateMultipleSupport;
  defaultExportFilename?: string;
  requiredData?: ExportRequiredDataModel[];
  includeUploadedFiles?: IncludeUploadedFiles;
  includeFileIds?: number[];
  childObjects?: ChildObjects;
  allowEditBeforeSending?: boolean;
  addressMapping?: string[];
  previewState?: ExportTemplatePreviewStates;
  visibilityCondition?: VisibilityOption;
  sourceFile?: string;
  filtering?: ExportTemplateSearchField[];
  defaultSenderAddress?: string;
  senderSelectionLocked?: boolean;
  backgroundJob?: boolean;
  distributionConfiguration?: CustomDataSearchFieldModel[];
  messageDistribution?: MessageDistributionOptions;
  distributionServiceSubscription?: number | null;
}

export enum ExportTemplatePreviewStates {
  Never = 0,
  AllowPreview = 1,
  AlwaysShow = 2,
}

export enum TemplateMultipleSupport {
  None = 0,
  InTemplate = 1,
  CreateZIP = 2,
  Combine = 3,
}

export enum IncludeUploadedFiles {
  Never = 0,
  Manual = 1,
  Individual = 2,
  Zipped = 3,
  CombineOutput = 4,
}

export enum MessageDistributionOptions {
  SingleTo = 0,
  SingleBCC = 1,
  IndividualTo = 2,
  IndividualBCC = 3,
}

export interface ChildObjects {
  childObjectTypes?: { [key: string]: string[] }[];
  parentObjectType?: string;
  parentObjectId?: string;
}

export interface ExportRequiredDataModel {
  mappingKey?: string;
  multiple?: boolean;
  output?: string;
  field?: string;
  requestedFields?: string[];
  filtering?: ExportTemplateSearchField[];
  children?: ExportRequiredDataModel[];
  distributionConfiguration?: CustomDataSearchFieldModel[];
}

export interface VisibilityOption {
  fieldCode?: string;
  fieldValue?: string[];
}

export interface ExportTemplateSearchField extends CustomDataSearchFieldModel {
  userInput?: boolean;
}

export interface IncludedExportTemplateModel {
  id: number;
  mode: ExportTemplateUsageMode;
}

export enum ExportTemplateUsageMode {
  SingleItem = 0,
  MultipleItems = 1,
}
